import { Recipe } from "../models/recipe";

// The URI to display for a recipe. Preference order:
//   1. your own freshly-picked photo still awaiting upload (localImageUri) —
//      instant and offline;
//   2. the offline cache of the remote image (cachedImageUri) — covers photos
//      set/changed on another device, so they show without a network round-trip;
//   3. the canonical remote URL (image) — fetched when online.
// Returns undefined when there's no image, so callers can render a placeholder.
export function recipeImageUri(
  recipe?: Pick<
    Recipe,
    "image" | "localImageUri" | "imagePendingUpload" | "cachedImageUri"
  > | null,
): string | undefined {
  if (recipe?.imagePendingUpload && recipe.localImageUri) return recipe.localImageUri;
  if (recipe?.cachedImageUri) return recipe.cachedImageUri;
  return recipe?.image || undefined;
}
